import React from 'react';
import PropTypes from 'prop-types';
import config from "../../../config/index";
import styles from './Arrow.module.scss';

const Arrow = (props) => {

	const env = config.env;
	const imagePrefix = config.envConfigs[env].imagePrefix;

	return (
		<img
			className={styles['icon-arrow']}
			src={`${imagePrefix}/assets/images/icon-arrow-left.svg`}
			onClick={props.back}
			id={props.id}
		/>
	);
};

Arrow.propTypes = {
	back: PropTypes.func,
};

export default Arrow;
